var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_indent = [];
var path = './';

pug_html = pug_html + "\n\u003Csection class=\"ot__contact\"\u003E\n  \u003Cp class=\"ot__contact--lead\"\u003EまずはWEBで相談！\u003C\u002Fp\u003E\u003Ca class=\"btn-grad\" href=\"\" data-aos=\"fade-up\" data-aos-delay=\"0\"\u003E\u003Cspan\u003E無料相談はこちら\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\n\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;